import { useState, useEffect } from "react";
import { Modal, Button, Table, Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import classes from "../../purchase.module.scss";
import Fetching from "@/components/Fetching/Fetching";

import { formatMilesDecimalNew } from "@/services/Utils";
import { ReactComponent as AlertSvg } from "@/assets/images/desktop/alert.svg";

import api from "@/services/api.service";

const OrdersSaleAssign = ({ showAssign, setShowAssign, base, item, assign }) => {
	const { addToast } = useToasts();
	const location = useLocation();

	const [isFetching, setIsFetching] = useState(false);
	const [data, setData] = useState([]);

	useEffect(() => {
		if (showAssign) {
			setIsFetching(true);
			api.get("/client/orders_sale/assign", { orders_sale_id: item.orders_sale_id }).then((response) => {
				setIsFetching(false);
				setData(response.details);
			});
		}
	}, [showAssign, item]);

	const selectItem = (i, j) => {
		let newItems = [...data];
		newItems[i].orders_availables.forEach((element, k) => {
			if (j === k) {
				newItems[i].orders_availables[k].selected = !newItems[i].orders_availables[k].selected;
			} else {
				newItems[i].orders_availables[k].selected = 0;
			}
		});
		setData(newItems);
	};

	const handleClose = () => {
		setShowAssign(false);
	};

	const handleConfirm = () => {
		let apply = false;
		data.forEach((element) => {
			element.orders_availables.forEach((order) => {
				if (order.selected) {
					apply = true;
				}
			});
		});

		if (apply) {
			const request = {
				base,
				element: data,
			};

			setShowAssign(false);
			assign(request, {
				onSuccess: () => {
					addToast(`Ordenes de compra asignadas correctamente.`, {
						appearance: "success",
					});
				},
			});
		} else {
			addToast(`No se han realizado modificaciones.`, {
				appearance: "error",
			});
		}
	};

	return (
		<Modal show={showAssign} onHide={handleClose} backdrop="static" keyboard={false} size="xl">
			<Modal.Header closeButton style={{ padding: "8px 15px" }}>
				<Modal.Title style={{ fontSize: "15px" }}>{`Asignar ${
					location.pathname.includes("facturas") ? " Ordenes de Compra" : " Facturas"
				}`}</Modal.Title>
			</Modal.Header>
			<Modal.Body className={classes.modalCodes}>
				{isFetching ? (
					<Fetching topMargin={"0em"}></Fetching>
				) : (
					<>
						{data &&
							data.map((item, i) => {
								return (
									<Row className={classes.rowAssign} key={i}>
										<Col md={12}>
											<div>
												<span style={{ fontSize: "14px", fontWeight: "700" }}>{`${
													item.product && item.product.tradename
												} ${formatMilesDecimalNew(item.quantity)}${item.unit_measurement}`}</span>
											</div>

											{item && item.orders_availables.length > 0 ? (
												<Table>
													<thead>
														<tr>
															<th
																style={{
																	width: "25%",
																}}
																className={classes.tableTh}
															>
																N° OC
															</th>
															<th
																style={{
																	width: "25%",
																}}
																className={classes.tableTh}
															>
																Producto
															</th>
															<th
																style={{
																	width: "25%",
																}}
																className={classes.tableTh}
															>
																Cantidad Disponible
															</th>
															<th
																style={{
																	width: "25%",
																}}
																className={classes.tableTh}
															></th>
														</tr>
													</thead>

													<tbody>
														{item &&
															item.orders_availables &&
															item.orders_availables.map((element, j) => {
																return (
																	<tr key={j}>
																		<td className={classes.tableTd}>{element.code_oc}</td>
																		<td className={classes.tableTd}>{element.product_name}</td>
																		<td className={classes.tableTd}>
																			{formatMilesDecimalNew(element.quantity_available)}
																			{element.unit_measurement}
																		</td>
																		<td className={classes.tableTd}>
																			<div
																				className={`${classes.buttonSelect} ${element.selected && classes.active}`}
																				onClick={() => selectItem(i, j)}
																			>
																				{element.selected ? "Seleccionado" : "Seleccionar"}
																			</div>
																		</td>
																	</tr>
																);
															})}
													</tbody>
												</Table>
											) : (
												<div className={classes.productNoAvailable}>
													<AlertSvg
														style={{
															marginRight: "10px",
														}}
													/>
													No fue posible encontrar el producto pendiente en las ordenes de compra
												</div>
											)}
										</Col>
									</Row>
								);
							})}
					</>
				)}
			</Modal.Body>
			<Modal.Footer style={{ padding: "5px" }}>
				<Button style={{ fontSize: "0.8em" }} variant="danger" onClick={() => handleClose()}>
					Cancelar
				</Button>
				<Button style={{ fontSize: "0.8em" }} variant="success" onClick={() => handleConfirm()}>
					Confirmar
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default OrdersSaleAssign;
